module.exports = __webpack_public_path__ + "img/logo.74dd7fc4.png";